import React, { useContext, useState } from 'react';

import {
  AppBar,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Toolbar,
  Typography,
} from '@material-ui/core';

import { Menu } from '@material-ui/icons';

import PropTypes from 'prop-types';

import translations from '../../languages/i18n';

import fieldStyles from '../../styles/fieldStyles';

import { avatarImage, complementaryColor, mainColor } from '../../utils/constants';

import { SessionContext } from '../../utils/context';

export default function Header({ handleChangeLang, lang, handleShowDrawer, type }) {
  const sessionContext = useContext(SessionContext);

  const classes = fieldStyles();

  const [language, setLanguage] = useState(lang);

  const handleChange = (event) => {
    setLanguage(event.target.value);
    handleChangeLang(event.target.value);
  };

  /* ***************************************************************************************************************************************** */
  // ATENCIÓ: la mida del text del selector d'idioma es control.la dins les etiquetes corresponents d'aquest fitxer, no al fitxer amb els estils,
  // en cas d'haver de canviar-la, ajustar l'style de: InputLabel, Select i els MenuItem
  //
  // Els style dins AppBar i Toolbar són necessaris perquè si no al codi del build no s'agafa el color de fons
  /* ****************************************************************************************************************************************** */

  return (
    <header>
      <AppBar position='static' style={{ background: mainColor }}>
        <Toolbar>
          <IconButton edge='start' style={{ color: complementaryColor }} aria-label='menu' onClick={() => handleShowDrawer(true)}>
            <Menu fontSize='large' />
          </IconButton>
          <div className={classes.language}>
            <FormControl variant='outlined' size='small' className={classes.languageSelector}>
              <InputLabel id='selectLangLabel' style={{ fontSize: '13px' }}>{translations['_lang']}</InputLabel>
              <Select
                labelId='selectLang'
                id='selectLangMenu'
                value={language}
                onChange={handleChange}
                label={translations['_selectLang']}
                style={{ fontSize: '12px' }}
              >
                <MenuItem value='ca' style={{ fontSize: '14px' }}>{translations['_catalan']}</MenuItem>
                <MenuItem value='es' style={{ fontSize: '14px' }}>{translations['_spanish']}</MenuItem>
                <MenuItem value='en' style={{ fontSize: '14px' }}>{translations['_english']}</MenuItem>
              </Select>
            </FormControl>
          </div>
          {/* ATENCIÓ: translations[type] té una s afegida per fer el pluarl */}
          {/* <Typography variant='h4' className={classes.appBarTitleHeader}>{`${translations['_' + type]}s`}</Typography> */}
          <Typography variant='h4' className={classes.appBarTitleHeader}>{sessionContext.username}</Typography>
          <img src={avatarImage[type]} alt='Generic Avatar' className={classes.appBarAvatarImageHeader} />
        </Toolbar>
      </AppBar>
    </header>
  );
}

// Indica i controla els props que se han de passar al component
Header.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  handleShowDrawer: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
